import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
import { LogOut } from "lucide-react";

export const Route = createFileRoute("/(auth)/waitinglist/")({
  component: RouteComponent,
});

function RouteComponent() {
  async function handleLogout() {
    try {
      await api.logout();
    } finally {
      window.location.href = "/auth";
    }
  }

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="space-y-4">
          <h1 className="text-2xl font-medium text-zinc-100">
            Thanks for Your Interest!
          </h1>
          <p className="text-zinc-400 leading-relaxed">
            We're currently invite-only. Reach out to{" "}
            <a
              href="https://x.com/mies"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-300 underline hover:text-zinc-200 transition-colors"
            >
              Mies
            </a>{" "}
            to get an invite.
          </p>
        </div>

        <Button
          type="button"
          onClick={handleLogout}
          variant="outline"
          className="bg-zinc-900 border-zinc-800 text-zinc-300 hover:bg-zinc-800 hover:text-zinc-200"
        >
          <LogOut className="mr-2 h-4 w-4" />
          Log out
        </Button>
      </div>
    </div>
  );
}
